import React from "react";
import HeaderPrint from "../components/HeaderPrint";
import "../styles/print.stye.css";
import SignaturePrint from "../components/SignaturePrint";
import CommentPrint from "../components/CommentPrint";
import RenderValue from "../components/RenderValue";
import { Checkbox, FormControlLabel } from "@mui/material";

const Form06 = ({
  header,
  sub_header,
  title,
  send_to,
  data,
  dataReportDetail,
  dataEmployee,
}: {
  header: string;
  sub_header: string;
  title: string;
  send_to: string;
  data: any;
  dataReportDetail: any;
  dataEmployee: any;
}) => {
  return (
    <div>
      <HeaderPrint
        header={header}
        sub_header={sub_header}
        title={title}
        send_to={send_to}
        data={{
          title: "วิทยาลัยพุทธศาสนานานาชาติ",
          date: data.created_date,
        }}
      />
      {/* line 1 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ข้าพเจ้า (ขื่อและนามสกุลภาษไทย)"}
          end_label={null}
          length={173}
          value={null}
          isParagraph={true}
        />
      </div>

      {/* new line */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"(ภาษาอังกฦษ)"}
          end_label={null}
          length={105}
          value={null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"ตำแหน่ง"}
          end_label={null}
          length={105}
          value={null}
          isParagraph={false}
        />
      </div>

      {/* new line */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"สังกัด"}
          end_label={"มีความประสงค์ขอลาอยู่ปฎิบัติงานในองค์กานระหว่างประเทศ"}
          length={100}
          value={null}
          isParagraph={false}
        />
      </div>

      {/* new line */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"จึงเสนอรายละเอียดเพื่อประกอบการพิจาระณาดังนี้"}
          end_label={null}
          length={0}
          value={null}
          isParagraph={false}
        />
      </div>

      {/* new line */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"๑. คำชี้แจงในการขออนุญาต"}
          end_label={null}
          length={0}
          value={null}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-8">
          <RenderValue
            start_label={"๑.๑ ข้อมูลเกี่ยวกับผู้ขอ"}
            end_label={null}
            length={0}
            value={null}
            isParagraph={false}
          />
        </span>
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-16">
          <RenderValue
            start_label={"๑.๑.๑ วันเดือปีเกีด"}
            end_label={null}
            length={100}
            value={null}
            isParagraph={false}
          />
        </span>

        <RenderValue
          start_label={"อายุ"}
          end_label={null}
          length={30}
          value={null}
          isParagraph={false}
        />

        <RenderValue
          start_label={"ปี"}
          end_label={"เดือน"}
          length={30}
          value={null}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-16">
          <RenderValue
            start_label={"๑.๑.๒ ขณะนี้กำลังปฎิบัติงานอยู่ในองค์การ"}
            end_label={null}
            length={130}
            value={null}
            isParagraph={false}
          />
        </span>
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-24">
          <RenderValue
            start_label={"ประเทศ"}
            end_label={null}
            length={55}
            value={null}
            isParagraph={false}
          />
        </span>
        <RenderValue
          start_label={"ตำแหน่ง"}
          end_label={null}
          length={55}
          value={null}
          isParagraph={false}
        />
        <RenderValue
          start_label={"ระดับ"}
          end_label={null}
          length={55}
          value={null}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-24">
          <RenderValue
            start_label={"ตั้งแต่วันที่"}
            end_label={"เป็นต้นมา"}
            length={75}
            value={null}
            isParagraph={false}
          />
        </span>
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-16">
          <RenderValue
            start_label={"๑.๑.๓ ได้รับอนุญาตให้ไปปฎิบัติงานติดต่อกันมาแล้ว"}
            end_label={"ครั้ง"}
            length={50}
            value={null}
            isParagraph={false}
          />
        </span>
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-24">
          <RenderValue
            start_label={"รวมระยะเวลาติดต่อกันมาแล้ว"}
            end_label={null}
            length={40}
            value={null}
            isParagraph={false}
          />
        </span>
        {/*  */}
        <RenderValue
          start_label={"ปี"}
          end_label={"เดือน"}
          length={40}
          value={null}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-24">
          <RenderValue
            start_label={"ครั้งที ๑ ตรั้งแต่วันที่"}
            end_label={null}
            length={70}
            value={null}
            isParagraph={false}
          />
        </span>
        {/*  */}
        <RenderValue
          start_label={"ถึงวันที่"}
          end_label={null}
          length={70}
          value={null}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-24">
          <RenderValue
            start_label={"ตามคำสั่งมหาวิทยาลัยที่"}
            end_label={null}
            length={65}
            value={null}
            isParagraph={false}
          />
        </span>
        {/*  */}
        <RenderValue
          start_label={"ลงวันที่"}
          end_label={null}
          length={70}
          value={null}
          isParagraph={false}
        />
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-16">
          <RenderValue
            start_label={"๑.๑.๔ สถานที่ติดต่อปัจจุบัน"}
            end_label={null}
            length={230}
            value={null}
            isParagraph={false}
          />
        </span>
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-16">
          <RenderValue
            start_label={null}
            end_label={null}
            length={230}
            value={null}
            isParagraph={false}
          />
        </span>
      </div>

      {/*  */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-16">
          <RenderValue
            start_label={null}
            end_label={null}
            length={230}
            value={null}
            isParagraph={false}
          />
        </span>
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-8">
          <RenderValue
            start_label={"๑.๒ ข้อมูลเกี่ยวกับการปฎิบัติงานที่ขอต่อ"}
            end_label={null}
            length={0}
            value={null}
            isParagraph={false}
          />
        </span>
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-16">
          <RenderValue
            start_label={"๑.๒.๑ ขออยู่ปฎิบัติงานอยู่ในองค์การ"}
            end_label={null}
            length={150}
            value={null}
            isParagraph={false}
          />
        </span>
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-24">
          <RenderValue
            start_label={"ตำแหน่ง"}
            end_label={null}
            length={70}
            value={null}
            isParagraph={false}
          />
        </span>
        {/*  */}
        <RenderValue
          start_label={"ระดับ"}
          end_label={null}
          length={67}
          value={null}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <span className="ml-16">
          <RenderValue
            start_label={"๑.๒.๒ ระยะเวลาที่ขออยู่ปฎิบัติงารต่อตั้งแต่วันที่"}
            end_label={null}
            length={50}
            value={null}
            isParagraph={false}
          />
        </span>

        <RenderValue
          start_label={"ถึงวันที่"}
          end_label={null}
          length={50}
          value={null}
          isParagraph={false}
        />
      </div>
      {/*  */}
      <div className="page-break"></div>

      {/*  */}
      <div className="a4-page">
        {/*  */}
        <div className="w-full">
          {/*  */}
          <span className="">
            <RenderValue
              start_label={"๑.๒.๓ อัตราค่าตอบแทนที่ได้รับ"}
              end_label={null}
              length={0}
              value={null}
              isParagraph={false}
            />
          </span>
        </div>
        {/*  */}
        <div className="w-full flex justify-start items-start">
          {/*  */}
          <span className="ml-12">
            <FormControlLabel
              control={<Checkbox />}
              label="เงินเดือน อัตราเงินเดือน/ปีละ"
              checked={false}
            />
          </span>
          <RenderValue
            start_label={null}
            end_label={null}
            length={80}
            value={null}
            isParagraph={false}
          />
        </div>
        {/*  */}
        <div className="w-full flex justify-start items-start">
          {/*  */}
          <span className="ml-12">
            <FormControlLabel
              control={<Checkbox />}
              label="ค่าที่พัก"
              checked={false}
            />
          </span>

          <RenderValue
            start_label={null}
            end_label={null}
            length={130}
            value={null}
            isParagraph={false}
          />
        </div>
        {/*  */}
        <div className="w-full flex justify-start items-start">
          {/*  */}
          <span className="ml-12">
            <FormControlLabel
              control={<Checkbox />}
              label="ค่าพาหนะในกานเดีนทาง"
              checked={false}
            />
          </span>

          <RenderValue
            start_label={null}
            end_label={null}
            length={100}
            value={null}
            isParagraph={false}
          />
        </div>
        {/*  */}
        <div className="w-full flex justify-start items-start">
          {/*  */}
          <span className="ml-12">
            <FormControlLabel
              control={<Checkbox />}
              label="อื่นๆ"
              checked={false}
            />
          </span>

          <RenderValue
            start_label={null}
            end_label={null}
            length={150}
            value={null}
            isParagraph={false}
          />
        </div>
        {/*  */}
        <div className="w-full flex justify-start items-start space-content">
          {/*  */}
          <span className="">
            <RenderValue
              start_label={"๑.๒.๔ เหตุผลความจำเป็นที่ขอยู่ปฎิบัติงานต่อ"}
              end_label={null}
              length={100}
              value={null}
              isParagraph={false}
            />
          </span>
        </div>
        {/*  */}
        <div className="w-full flex justify-start items-start space-content">
          {/*  */}
          <span className="">
            <RenderValue
              start_label={null}
              end_label={null}
              length={230}
              value={null}
              isParagraph={false}
            />
          </span>
        </div>
        {/*  */}
        <div className="w-full flex justify-start items-start space-content">
          {/*  */}
          <span className="">
            <RenderValue
              start_label={null}
              end_label={null}
              length={230}
              value={null}
              isParagraph={false}
            />
          </span>
        </div>
        {/*  */}
        <div className="w-full flex justify-start items-start space-content">
          {/*  */}
          <span className="">
            <RenderValue
              start_label={"๑.๒.๕ ปะโยชน์ที่ทางมหาวิทยาลัยจะได้รับ"}
              end_label={null}
              length={100}
              value={null}
              isParagraph={false}
            />
          </span>
        </div>
        {/*  */}
        <div className="w-full flex justify-start items-start space-content">
          {/*  */}
          <span className="">
            <RenderValue
              start_label={null}
              end_label={null}
              length={230}
              value={null}
              isParagraph={false}
            />
          </span>
        </div>
        {/*  */}
        <div className="w-full flex justify-start items-start space-content">
          {/*  */}
          <span className="">
            <RenderValue
              start_label={null}
              end_label={null}
              length={230}
              value={null}
              isParagraph={false}
            />
          </span>
        </div>
        {/*  */}
        <div className="w-full flex justify-start items-start space-content">
          {/*  */}
          <span className="">
            <RenderValue
              start_label={"ขอรับรองว่าข้อความข้างต้นถูกต้องเป็นจริงทุกปะการ"}
              end_label={null}
              length={0}
              value={null}
              isParagraph={true}
            />
          </span>
        </div>
        {/*  */}
        <div className="w-full ml-24">
          <SignaturePrint
            title={"นมัสการมาด้วยความเคารพ"}
            prefix={`ลงชื่อ`}
            position={""}
            isDate={false}
            isPosition={false}
            data={{}}
          />
        </div>
        {/*  */}
        <div className="w-full">
          <CommentPrint
            title={"ความคิดเห็นของหัวหน้าส่วนงาน"}
            isCheckBoxApprove={false}
            sxTitle=""
            amountLine={2}
            isParagraph={true}
            data={{
              isApprove: data.leave_status === "approve third" ? true : false,
              comment: data.leave_approve_first_comment ?? "",
            }}
            lengthDot={230}
          />
        </div>

        <div className="w-full ml-48">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </div>

        <div className="w-full">
          <CommentPrint
            title={"ความคิดเห็นของรองอธิการบดีฝ่ายบริหาร"}
            isCheckBoxApprove={false}
            sxTitle=""
            amountLine={2}
            isParagraph={true}
            data={{
              isApprove: data.leave_status === "approve third" ? true : false,
              comment: data.leave_approve_first_comment ?? "",
            }}
            lengthDot={230}
          />
        </div>

        <div className="w-full ml-48">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </div>

        <div className="w-full">
          <CommentPrint
            title={"คำสั่งของอธิการบดี"}
            isCheckBoxApprove={false}
            sxTitle=""
            amountLine={2}
            isParagraph={true}
            data={{
              isApprove: data.leave_status === "approve third" ? true : false,
              comment: data.leave_approve_first_comment ?? "",
            }}
            lengthDot={230}
          />
        </div>

        <div className="w-full ml-48">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </div>
      </div>
    </div>
  );
};

export default Form06;
